<div class="progress-bars-se">
    <div class="progress-bar-se" *ngFor="let item of getProgressData()">
        <div class="progress-bar-se__header">
            <span class="progress-bar-se__label">{{ item.name }}</span>
        </div>

        <div class="progress-bar-se__header">
            <span class="progress-bar-se__level-name">{{item.levelName}}</span>
            <span class="progress-bar-se__value">{{ item.score }}%</span>
        </div>
        <div class="progress-bar-se__track">
            <div class="progress-bar-se__fill" [style.width.%]="item.score" [style.backgroundColor]="item.color">
            </div>
        </div>
    </div>
</div>